var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-margin"},[_c('h1',{staticClass:"d-block text-center"},[_vm._v("Essa página não foi encontrada")])])
}]

export { render, staticRenderFns }